import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-index-contact',
    templateUrl: './index-contact.component.html',
    styleUrls: ['./index-contact.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IndexContactComponent {}
